export default __webpack_public_path__ + "static/media/bmj.19e09bd8.jpeg";